import PaginationFooter from "components/pagination/components/pagination-footer";
import TableRownColumnUnclickable from "components/table-row-column-unclickable";
import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "components/uikit-adapter/index";
import DeleteIcon from "images/icn-trash-bin.svg";
import IconButton from "material-ui/IconButton";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { isFeatureEnabled } from "utils/feature-flags";

const SupplierGroupList = ({
  data,
  countData,
  refreshSearch,
  handleEdit,
  handleDelete,
  qtRegsPerPage,
  profileAdminOrMasterData,
}) => {
  const [hideEmail, setHideEmail] = useState(true);

  useEffect(() => {
    const checkFeatureFlag = async () => {
      const enabled = await isFeatureEnabled("FeatureRoleBasedPermissions");
      setHideEmail(enabled);
    };
    checkFeatureFlag();
  }, []);

  return (
    <Table
      fixedHeader
      fixedFooter
      multiSelectable={false}
      selectable={false}
      wrapperStyle={{ height: "100%" }}
      bodyStyle={{
        height: "calc(100% - 110px)",
        borderTop: "1px solid rgb(224, 224, 224)",
        backgroundColor: "var(--color-contrast-white)",
      }}
      onCellClick={handleEdit}
    >
      <TableHeader
        displaySelectAll={false}
        adjustForCheckbox={false}
        style={{ borderBottom: "none" }}
      >
        <TableRow style={{ borderBottom: "none" }}>
          <TableHeaderColumn>
            {intl.get("master-data.general-configuration.name")}
          </TableHeaderColumn>
          {!hideEmail && <TableHeaderColumn>Email</TableHeaderColumn>}
          <TableHeaderColumn />
        </TableRow>
      </TableHeader>

      <TableBody displayRowCheckbox={false} showRowHover>
        {data.map((v) => (
          <TableRow key={v.Id} style={{ cursor: "pointer" }}>
            <TableRowColumn>{v.Nome}</TableRowColumn>
            {!hideEmail && <TableRowColumn>{v.Email ? v.Email.join("; ") : ""}</TableRowColumn>}
            <TableRownColumnUnclickable style={{ positon: "relative", textAlign: "right" }}>
              {profileAdminOrMasterData && (
                <div
                  title={intl.get("master-data.suppliers.usersGroupSupplier.deleteSupplierGroup")}
                >
                  <IconButton onClick={() => handleDelete(v.Id)}>
                    <img src={DeleteIcon} alt="delete-icon" />
                  </IconButton>
                </div>
              )}
            </TableRownColumnUnclickable>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
        <PaginationFooter
          countPerPage={qtRegsPerPage}
          countData={countData}
          refreshSearch={refreshSearch}
        />
      </TableFooter>
    </Table>
  );
};

SupplierGroupList.propTypes = {
  countData: PropTypes.any.isRequired,
  data: PropTypes.shape({
    map: PropTypes.func,
  }).isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleEdit: PropTypes.any.isRequired,
  profileAdminOrMasterData: PropTypes.any.isRequired,
  qtRegsPerPage: PropTypes.any.isRequired,
  refreshSearch: PropTypes.any.isRequired,
};

export default SupplierGroupList;
